import { Injectable, signal } from '@angular/core';
import { isNotEmpty } from '@partners/utils';
import { IHttpLoader } from '../../http';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loaderState$$ = signal<IHttpLoader>(null);
  #loaderMap = new Map<string, IHttpLoader>();

  constructor() {}

  /**
   * toggle loader's state (on/off)
   * @param nextState a boolean indication wether to show or hide the loader
   * @param options
   *    (1) token: unique id for current loader state
   *    (2) method: http method ('get' | 'post'..) in case we want to change loader behavior
   *        per http verb (we do, we display messages mainly in put methods)
   *    (3) on: is the loader on or off indication
   */
  updateState(state: IHttpLoader) {
    /** add|update current loader's state */
    this.#loaderMap.set(state.token, state);

    /** find any loaders with "on" indication set to true (means loader is still showing) */
    const isLoaderOn = isNotEmpty(Array.from(this.#loaderMap.values()).find((loader: IHttpLoader) => loader?.toggle));

    /** override default loader behavior (on=true), in case we don't want to show loader on http call  */
    const shouldUpdateLoader = state?.toggle || (!state?.toggle && !isLoaderOn);

    if (shouldUpdateLoader) {
      this.loaderState$$.set(state);
    }
  }
}
